import { Injectable} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { UserPruBE } from './shared/user-management.model';

@Injectable()
export class UserManagementService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'Admin';

    deletePruUser(currentUserId: string, deleteThisId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeletePruUser/?currentUserId==${currentUserId}&deleteThisId=${deleteThisId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getPruList(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruList/`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getPruUsersListForUser(currentUserId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruUsersListForUser/?userId=${currentUserId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getPruUsersListForPruId(pruId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruUsersListForPruId/?pruId=${pruId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }
    
    getADUser(userId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetADUser/?userId=${userId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }
    
    getPruUser(userId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruUser/?userId=${userId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updatePruUser( pruUser:UserPruBE): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json'); 
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(pruUser);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/UpdatePruUser`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/user-management/user-management.service.ts